import {ApplicationConfig, DEFAULT_CURRENCY_CODE, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {HttpClient, provideHttpClient, withInterceptors, withXsrfConfiguration} from '@angular/common/http';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {routes} from './app.routes';
import {provideToastr} from 'ngx-toastr';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from 'ngx-webstorage';
import {apiInterceptor} from './interceptors/api.interceptor';
import {mockInterceptor} from './interceptors/mock.interceptor';
import {MissingTranslationHandler, provideTranslateService, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {DebugMissingTranslationHandler} from './services/translate/debug-missing-translation-handler';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {ModalModule} from 'ngx-bootstrap/modal';
import {LocaleProvider} from './services/locale-service/locale.provider';
import {defineLocale, enGbLocale, deLocale} from 'ngx-bootstrap/chronos';
import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en'
import localeDe from '@angular/common/locales/de'

defineLocale('de', deLocale);
defineLocale('en', enGbLocale);

// angular locale
registerLocaleData(localeEn, 'en')
registerLocaleData(localeDe, 'de')

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    LocaleProvider,
    provideRouter(routes, withComponentInputBinding()),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideHttpClient(
      withInterceptors([apiInterceptor, mockInterceptor]),
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      })),
    provideAnimations(),
    provideToastr({
      countDuplicates: true,
      tapToDismiss: false,
      closeButton: true,
      maxOpened: 3,
      progressBar: false,
      progressAnimation: 'decreasing',
      enableHtml: true,
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true
    }),
    provideNgxWebstorage(
      withLocalStorage(),
      withSessionStorage()
    ),
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: DebugMissingTranslationHandler,
      },
    }),
    importProvidersFrom(
      LoggerModule.forRoot({
        level: NgxLoggerLevel.DEBUG,
        serverLogLevel: undefined,
        serverLoggingUrl: undefined
      }),
      ModalModule.forRoot(),
    ),
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
  ],
};
